<div class="form-header">
  <span *ngIf="edited.id || panel > 0">Edit</span>
  <span *ngIf="!edited.id && panel === 0">Add</span>
  patient <span *ngIf="panel === 1">families</span><span *ngIf="panel === 2">addresses</span><span *ngIf="panel === 3">phones &amp; social media</span>
</div>
<form class="justified-flex" [formGroup]="patientForm" (ngSubmit)="onSubmitForm(patientForm)" >
<div class="dialog-container" *ngIf="panel === 0">
  <div class="field" required>
    <mat-form-field>
      <input matInput placeholder="Email" email formControlName="email"  name="email">
    </mat-form-field>
  </div>
  <div class="field" required >
    <mat-form-field >
      <input matInput placeholder="First name" formControlName="firstName" name="firstName"minLength="5" maxLength="50">
    </mat-form-field>
  </div>
  <div class="field" required >
    <mat-form-field >
      <input matInput placeholder="Last name" formControlName="lastName" name="lastName" minLength="5" maxLength="50">
    </mat-form-field>
  </div>
  <div class="field" required >
    <mat-form-field >
      <input matInput  placeholder="Date of Birth" name="dob" type="date" formControlName="dob" placeholder="Choose a date">
    </mat-form-field>
  </div>
  <div class="field">
    <mat-form-field  >
      <mat-select  name="sex" formControlName="sex" placeholder="Sex">
        <mat-option *ngFor="let sex of sexes" [value]="sex">{{sex}}</mat-option>
      </mat-select>
    </mat-form-field>
  </div> 

  <div class="field">
    <mat-form-field >
      <input matInput maxLength="10" name="identifier" placeholder="Identifier" formControlName="identifier">
    </mat-form-field>
  </div>
  <div class="field" *ngIf="providers.length > 1">
    <mat-form-field  >
      <mat-select  name="provider" formControlName="provider" placeholder="Provider">
        <mat-option *ngFor="let provider of providers" [value]="provider.id">{{provider.name}}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <mat-form-field class="full-field">  
    <input type="text" formControlName="tags" name="tags" matInput placeholder="Enter tags separated by commas" >

  </mat-form-field>
</div>
<div class="dialog-container-full-column" *ngIf="panel === 1">
  <div class="horizontal-border-panel">
    <div class="panel-label"> <mat-label>Search for a family or enter a new family identifier.</mat-label></div>
    <div class="panel-body">
      <mat-form-field class="full-field">  
        <button class="search-icon" (click)="getPageOfFamilies($event)"  matPrefix mat-button><mat-icon>search</mat-icon></button>
        <input type="text" (input)="getPageOfFamilies($event)" formControlName="familyIdentifier" name="familyIdentifier" matInput placeholder="Search for a family" [matAutocomplete]="auto">
        <mat-autocomplete  (optionSelected)='familySelected()' #auto="matAutocomplete">
          <mat-option *ngFor="let family of families" [value]="family.familyIdentifier">{{family.description}}</mat-option>
        </mat-autocomplete>
      </mat-form-field>
    <button class="add-button" [disabled]="!validFamilySelected()"  (click)="addToFamily()" type="button" mat-flat-button color="primary" >Add</button>
    <mat-form-field  >
      <mat-label>Relationship type</mat-label>
      <mat-select  name="familyRelationship" formControlName="familyRelationship" [disabled]="isNewFamily">
        <mat-option *ngFor="let r of getFamilyRelationships()" [value]="r">{{r}}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</div>
  <div class="list-panel">
    <div class="patient-family-item" *ngFor="let pf of patientFamilies; let n = index">
      <div class="patient-family-description">{{pf.description}} </div>
      <button type="button" *ngIf="pf.relationship != 'PRIMARY'" class="remove-button" (click)="onRemovePatientFamily(pf.familyIdentifier)" mat-icon-button >
        <mat-icon>delete_outline</mat-icon>
      </button>
    </div>
  </div>
</div>
<div class="dialog-container-full-column" *ngIf="panel === 2">
  <div class="horizontal-border-panel">
    <div class="panel-body">
      <mat-form-field class="full-field">
        <button class="search-icon" (click)="searchAddresses($event)"  matPrefix mat-button><mat-icon>search</mat-icon></button>
        <input type="text" (input)="searchAddresses($event)" formControlName="address" name="address" matInput placeholder="Search for an existing address" [matAutocomplete]="auto">

        <mat-autocomplete  #auto="matAutocomplete">
            <mat-option *ngFor="let address of addresses" [value]="address.description">{{address.description}}</mat-option>
        </mat-autocomplete>
      </mat-form-field>
    <button class="add-button" [disabled]="!validAddressSelected()"  (click)="addAddress()" type="button" mat-flat-button color="primary" >Add</button>
  </div>
</div>
<div class="horizontal-border-panel">
 <div class="panel-label"> <mat-label>Create and add a new address.</mat-label></div>
 <div class="panel-body">
    <div class="field-small" required>
      <mat-form-field>
        <mat-label>Street Address 1</mat-label>
        <input matInput formControlName="street1"  name="street1">
      </mat-form-field>
    </div>
    <div class="field-small" required>
      <mat-form-field>
        <mat-label>Street Address 2</mat-label>
        <input matInput formControlName="street2"  name="street2">
      </mat-form-field>
    </div>
    <div class="field-small" required>
      <mat-form-field>
        <mat-label>City</mat-label>
        <input matInput formControlName="city"  name="city">
      </mat-form-field>
    </div>
    <div class="field-small">
      <mat-form-field  >
        <mat-label>State</mat-label>
        <mat-select  name="state" formControlName="state" >
          <mat-option *ngFor="let state of us_states" [value]="state.id">{{state.name}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div> 
    <div class="field-small">
      <mat-form-field >
        <mat-label>Postal code</mat-label>
        <input matInput formControlName="postalCode" minLength="5" maxLength="7" 
        name="postalCode">
      </mat-form-field>
    </div> 
    

    <button class="add-button"  [disabled]="!validAddressSelected(toAddressInfo())" (click)="createAddress()" type="button" mat-flat-button color="primary">Create</button>
  </div>
</div>
  <div class="list-panel">
    <div class="patient-family-item" *ngFor="let address of patientAddresses; let n = index">
      <div class="patient-family-description">{{address.description}} </div>
      <button type="button" class="remove-button" (click)="onRemoveAddress(address.description)" mat-icon-button >
        <mat-icon>delete_outline</mat-icon>
      </button>
    </div>
  </div>
</div>
<div class="dialog-container-full-column" *ngIf="panel === 3">
  <div class="horizontal-border-panel">
    <div class="panel-body">
      <mat-form-field class="full-field">
        <button class="search-icon" (click)="searchPhones($event)"  matPrefix mat-button><mat-icon>search</mat-icon></button>
        <input type="text" (input)="searchPhones($event)" formControlName="phone" name="phone" matInput placeholder="Search for an existing phone" [matAutocomplete]="auto">

        <mat-autocomplete  #auto="matAutocomplete">
            <mat-option *ngFor="let phone of phones" [value]="phone.description">{{phone.description}}</mat-option>
        </mat-autocomplete>
      </mat-form-field>
    <button class="add-button" [disabled]="!validPhoneSelected()"  (click)="addPhone()" type="button" mat-flat-button color="primary" >Add</button>
  </div>
</div>
<div class="horizontal-border-panel">
 <div class="panel-label"> <mat-label>Create and add a new phone.</mat-label></div>
 <div class="panel-body">
    <div class="field" required>
      <mat-form-field>
        <input matInput type="tel" placeholder="Enter area code and number (exactly 10 digits)" formControlName="newPhone"  name="newPhone">
      </mat-form-field>
    </div>
   

    <button class="add-button"  [disabled]="!validPhoneSelected(toPhoneInfo())" (click)="createPhone()" type="button" mat-flat-button color="primary">Create</button>
  </div>
</div>
  <div class="list-panel">
    <div class="patient-family-item" *ngFor="let phone of patientPhones; let n = index">
      <div class="patient-family-description">{{phone.description}} </div>
      <button type="button" class="remove-button" (click)="onRemovePhone(phone.description)" mat-icon-button >
        <mat-icon>delete_outline</mat-icon>
      </button>
    </div>
  </div>
  <div class="horizontal-border-panel">
    <div class="panel-body">
      <div class="field" required>
        <mat-form-field>
          <input matInput type="text" placeholder="Enter platform name" formControlName="newContactType"  name="newContactType">
        </mat-form-field>
      </div>
      <div class="field" required>
        <mat-form-field>
          <input matInput type="text" placeholder="Enter platform identifier" formControlName="newContactId"  name="newContactId">
        </mat-form-field>
      </div>
    <button class="add-button" [disabled]="!validContactInfoEntered()"  (click)="addContactInfo()" type="button" mat-flat-button color="primary" >Add</button>
  </div>
</div>

  <div class="list-panel">
    <div class="patient-family-item" *ngFor="let contactInfo of contactInfo; let n = index">
      <div class="patient-family-description"><b>{{contactInfo.contactType}} :</b> {{contactInfo.contactIdentifier}}</div>
      <button type="button" class="remove-button" (click)="onRemoveContactInfo(n)" mat-icon-button >
        <mat-icon>delete_outline</mat-icon>
      </button>
    </div>
  </div>
</div>
<div class="button-container">
  <button class="dialog-button" [disabled]="!isFormValid()" type="submit" mat-flat-button color="primary" >Save</button>
  <button class="dialog-button" *ngIf="panel > 0"  type="button" (click)="onPrevious()" mat-flat-button color="primary" >Previous</button>
  <button class="dialog-button" *ngIf="panel  < 3"   type="button" (click)="onNext()" mat-flat-button color="primary" >Next</button>
  <button class="dialog-button" mat-flat-button color="primary" type="reset" (click)="close()">Cancel</button>
</div>
</form>